import styled from "@emotion/styled";
import { Card, Col, Row, Tabs, Typography } from "antd";
import { goBack, chat, search } from "assets/icons/index";
import { useNavigate } from "react-router-dom";

import { useAppSelector, useAppDispatch } from 'store'

import { setTabSelected } from 'store/slices/orderSlice'
import { useState } from "react";
import { useGetPrepareShip, useGetTransportShipped } from "hooks/useShipping";
import ShippingPrepare from "./ShippingPrepare";
import ShippingShipped from "./ShippingShipped";
import ShippingSuccess from "./ShippingSuccess";
 
const Shipping = () => {
  const navigate = useNavigate();

  const [searchInput, setSearchInput] = useState<string>('');


  // const [offsetWaitDC, setOffsetWaitDC] = useState(0);
  // const [limitWaitDC, setLimitWaitDC] = useState(10);

  const pagging = useAppSelector((state) => state.order);

  const { data: dataPrepareShip, isLoading: prepareShipLoading ,refetch: refectPrepareShip } = useGetPrepareShip({
    status: "inprocess",
    search: searchInput,
    sort_by: "desc",
    offset: pagging.dataPrepareShipped.offset,
    limit: pagging.dataPrepareShipped.limit
  })

  const { data: dataTransportShipped, isLoading: transportShippedLoading, refetch: refetchTransportShipped } = useGetTransportShipped(
      {
        status: "wait_agent_confirm",
        search: searchInput,
        sort_by: "desc",
        offset: pagging.dataTransportShipped.offset,
        limit: pagging.dataTransportShipped.limit
      }
    );

    const { data: dataTransportSuccess, isLoading: transportSuccessLoading, refetch: refetchTransportSuccess } = useGetTransportShipped(
      {
        status: "complete",
        search: searchInput,
        sort_by: "desc",
        offset: pagging.dataTransportSuccess.offset,
        limit: pagging.dataTransportSuccess.limit
      }
    );


  const items = [
    {
      // (${inprosessItems?.length || 0})
      label: `เตรียมจัดส่ง (${dataPrepareShip?.data?.total_record ?? 0})`,
      key: "0",
      children: 
      // <WaitingPaymentTable data={undefined}/>
      <ShippingPrepare 
        data={dataPrepareShip?.data} 
        isLoading={prepareShipLoading} 
        refetch={refectPrepareShip}
        setSearchInput={setSearchInput}
        searchInput={searchInput}
        refetchPrepare={refectPrepareShip}
      />
      ,
    },
    {
      // (${inprosessItems?.length || 0})
      label: `ระหว่างจัดส่ง (${dataTransportShipped?.data?.total_record ?? 0})`,
      key: "1",
      children: 
      // <WaitingPaymentTable data={undefined}/>
      <ShippingShipped 
        data={dataTransportShipped?.data} 
        isLoading={transportShippedLoading} 
        refetch={refetchTransportShipped}
        setSearchInput={setSearchInput}
        searchInput={searchInput}
        refetchPrepare={refectPrepareShip}
      />
      ,
    },
    {
      // (${inprosessItems?.length || 0})
      label: `จัดส่งสำเร็จ (${dataTransportSuccess?.data?.total_record ?? 0})`,
      key: "2",
      children: 
      // <WaitingPaymentTable data={undefined}/>
      <ShippingSuccess
        data={dataTransportSuccess?.data} 
        isLoading={transportSuccessLoading} 
        refetch={refetchTransportSuccess}
        setSearchInput={setSearchInput}
        searchInput={searchInput}
        refetchPrepare={refectPrepareShip}
      />
      ,
    },

  ];

  return (
    <>

        <Card bordered={false} className="criclebox h-full tabs-mobile">
          <HeaderTabs>
            <IconWrapper
              onClick={() => {
                navigate("/setting");
              }}
            >
              <SpanIcon>{goBack}</SpanIcon>
            </IconWrapper>
            <Typography.Title level={5}>การจัดส่ง</Typography.Title>
            <RightIconWrapper>
            </RightIconWrapper>
          </HeaderTabs>
          <Row className="rowgap-vbox" gutter={[24, 0]}  >
            <Col sm={24} md={24}>
              <Tabs
                defaultActiveKey={'0'}
                style={{ height: "100%" }}
                items={items}
                key="key"
              />
            </Col>
          </Row>
        </Card>
    </>
  );
};

export default Shipping;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
